import useCarouselPageSize from "./useCarouselPageSize";
import getCarouselMode from "./getCarouselMode";

const useCarouselSettings = () => {
  const pageSize = useCarouselPageSize();
  const carouselMode = getCarouselMode(pageSize);

  return { carouselMode, pageSize };
};

export default useCarouselSettings;
